import { TeacherDataService } from './../shared/teacher-data.service';
import { Component, OnInit, TemplateRef, ViewChild, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  Login,
  BaseControl,
  ConfirmComponent,
  Option,
  LoginSaved,
  Const
} from '@app/shared';
import { CreateUserLoginFormService } from './shared/create-user-login.form.service';
import { CreateUserLoginDataService } from './shared/create-user-login.data.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { environment } from '@env/environment';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-create-user-login',
  templateUrl: './create-user-login.component.html',
  styleUrls: ['./create-user-login.component.scss'],
  providers: [
    CreateUserLoginFormService,
    CreateUserLoginDataService,
    TeacherDataService
  ]
})
export class CreateUserLoginComponent implements OnInit, OnDestroy {

  // Id del registro
  @Input() idRegistration: number;
  // Informacion de el login del usuario
  @Input() userLogin: Login;
  // Define la pregunta de confirmacion
  question = '';
  // Contiene temporalmente la empresa seleccionada
  tmpCompany = -1;
  // Contiene temporalmente la sede seleccionada
  tmpSede = -1;
  // Define cuando es un modificar o un crear
  update = false;
  // Define cuando se muestra el formulario de cambio de contraseña
  changePassword = false;
  // Detecta cuando se esta ejecutando los cambios en el formulario
  detectChangeForm = false;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    createUserSystem: false,
    reviewUserSystem: false,
    updateUserSystem: false,
    deleteUserSystem: false,
  };
  // Contiene temporalmente la informacion del formulario de actualizacion de login
  dataFormUpdate: any;
  // opciones de los grupos
  optRoles: Array<Option> = [];
  // opciones de las empresas
  optCompanies: Array<Option> = [];
  // opciones de las empresas
  optCharges: Array<Option> = [];
  // opciones de las sedes
  optSedes: Array<Option> = [];
  // Contiene las opciones de los formularios de creacion o edicion de el login
  options = {};
  // Contiene los templates del formulario de edicion del login
  templates = {};
  // Referencia de la modal
  private modalRef: BsModalRef;
  // Controles de el formulario
  controls: BaseControl<any>[] = [];
  // Formulario de creacion de login
  formLogin: FormGroup = new FormGroup({
    txtNameUser: new FormControl(null, [Validators.pattern('^[a-z0-9_\-\\_\ü]+$'), Validators.required]),
    txtPassword: new FormControl(null, [Validators.minLength(6), Validators.maxLength(15), Validators.required]),
    txtRedPassword: new FormControl(null, [Validators.minLength(6), Validators.maxLength(15), Validators.required]),
    cboGroups: new FormControl(null),
    cboCompany: new FormControl(null, [Validators.required]),
    cboSede: new FormControl(null, [Validators.required]),
    cboCharge: new FormControl(null, [Validators.required]),
    chActive: new FormControl(true, [Validators.required]),
  });
  // Formulario cambio de contraseña
  formChangePassword: FormGroup = new FormGroup({
    txtPassword: new FormControl(null, [Validators.minLength(6), Validators.maxLength(15), Validators.required]),
    txtRedPassword: new FormControl(null, [Validators.minLength(6), Validators.maxLength(15), Validators.required]),
  });
  // Para mostrar información de debug.
  debug: boolean = environment.showDebugHelpers;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia del template de la modal
  @ViewChild('templateModalForm') templateModalForm: TemplateRef<any>;
  // Referencia del template sel select para el formulario de edicion de login
  @ViewChild('ngTplSelect') ngTplSelect: TemplateRef<any>;
  @ViewChild('ngTplMultiSelect') ngTplMultiSelect: TemplateRef<any>;
  // Referencia del template del boton de cambio de contraseña para el formulario de edicion de login
  @ViewChild('tplChangePassword') tplChangePassword: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirmAction') private confirmAction: ConfirmComponent;
  // Emite el evento de guardar
  @Output() sended: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private modalService: BsModalService,
    private culfs: CreateUserLoginFormService,
    private culds: CreateUserLoginDataService,
    private toastr: ToastrService,
    private tds: TeacherDataService,
    private as: AuthenticationService,
  ) { }

  ngOnInit() {

    // Permiso para crear usuario del sistema
    this.activateAction.createUserSystem = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.createUserSystem,
    );
    // Permiso para ver los usuarios del sistema
    this.activateAction.reviewUserSystem = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.reviewUserSystem,
    );
    // Permiso para modificar los usuarios del sistema
    this.activateAction.updateUserSystem = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.updateUserSystem,
    );
    // Permiso para eliminar usuario del sistema (anular - sin uso)
    this.activateAction.deleteUserSystem = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.deleteUserSystem,
    );

    if (!this.activateAction.createUserSystem) {
      this.formLogin.disable();
    }

    this.formLogin.valueChanges.subscribe(data => {
      this.changeForm({change: data, form: this.formLogin});
    });
    this.culds.getRoles().subscribe(data => {
      if (data && data.length) {
        data.forEach(rol => {
          this.optRoles.push({
            key: rol.id,
            value: rol.nombre
          });
        });
        this.options['optionRoles'] = this.optRoles;
      }
    });
    this.culds.getCompanies().subscribe(data => {
      if (data && data.length) {
        data.sort((a, b) => a.id - b.id);
        data.forEach(rol => {
          this.optCompanies.push({
            key: rol.id,
            value: rol.nombre
          });
        });
        this.options['optCompanies'] = this.optCompanies;
      }
    });
    this.culds.getCharges().subscribe(data => {
      if (data && data.length) {
        data.sort((a, b) => a.id - b.id);
        data.forEach(rol => {
          this.optCharges.push({
            key: rol.id,
            value: rol.nombre
          });
        });
        this.options['optCharges'] = this.optCharges;
      }
    });

    this.templates = {
      ngMultiSelect: this.ngTplMultiSelect,
      ngSelect: this.ngTplSelect,
      tplChangePassword: this.tplChangePassword
    };
    this.formLogin.controls['cboCompany'].disable();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Abre la modal de edicion o creacion de login
   *
   * @memberof CreateUserLoginComponent
   */
  async open () {
    if (this.userLogin) {
      const user = await this.culds.getUserLogin(this.userLogin.id);
      const groups: Array<number> = [];

      if (user.groups && user.groups.length) {
        user.groups.forEach(group => {
          groups.push(group.id);
        });
      }

      user['groups_user'] = groups;
      if (user.empresa && user.empresa.id) {
        this.tmpCompany = Number(user.empresa.id);
      } else {
        this.tmpCompany = Number(this.optCompanies[0].key);
        user.empresa = {
          id: this.tmpCompany,
          nombre: '',
          descripcion: '',
        };
      }
      this.formLogin.controls['cboCompany'].setValue(this.tmpCompany);
      this.culds.getSedes(this.tmpCompany).subscribe(sedes => {
        this.optSedes = [];
        if (sedes && sedes.length) {
          sedes.forEach(sede => {
            this.optSedes.push({
              key: sede.id,
              value: sede.nombre
            });
          });
          this.options['optSedes'] = this.optSedes;
          this.controls = this.culfs.getFieldsCompensaciones(this.options, this.templates, user);
        }
      });
      this.controls = this.culfs.getFieldsCompensaciones(this.options, this.templates, user);
      this.update = true;
    } else {
      this.update = false;
      this.tmpCompany = Number(this.optCompanies[0].key);
      this.formLogin.reset();
      this.formLogin.controls['chActive'].setValue(true);
      this.formLogin.controls['cboCompany'].setValue(this.tmpCompany);
      if (!this.optSedes.length) {
        this.culds.getSedes(this.tmpCompany).subscribe(sedes => {
          if (sedes && sedes.length) {
            sedes.forEach(sede => {
              this.optSedes.push({
                key: sede.id,
                value: sede.nombre
              });
            });
            this.options['optSedes'] = this.optSedes;
          }
        });
      }
      this.formLogin.valueChanges.subscribe(data => {
        if (!this.detectChangeForm) {
          this.detectChangeForm = true;
          if (!this.formLogin.controls['cboCompany'].value) {
            this.formLogin.controls['cboSede'].disable();
            delete this.options['optSedes'];
          } else {
            if (this.tmpCompany !== Number(this.formLogin.controls['cboCompany'].value)) {
              this.tmpCompany = Number(this.formLogin.controls['cboCompany'].value);
              this.culds.getSedes(Number(this.formLogin.controls['cboCompany'].value)).subscribe(sedes => {
                this.formLogin.controls['cboSede'].setValue(null);
                this.optSedes = [];
                if (sedes && sedes.length) {
                  sedes.forEach(sede => {
                    this.optSedes.push({
                      key: sede.id,
                      value: sede.nombre
                    });
                  });
                  this.options['optSedes'] = this.optSedes;
                }
              });
            }
            this.formLogin.controls['cboSede'].enable();
          }
          this.detectChangeForm = false;
        }
      });
    }
    this.modalRef = this.modalService.show(this.templateModalForm, { class: 'modal-lg-personalized' });
    this.modalService.onHidden.subscribe((response: any) => {
      if (response === 'backdrop-click') {
        this.closeForm();
      }
    });
  }

  /**
   * Cierra el componente
   *
   * @memberof CreateUserLoginComponent
   */
  closeForm () {
    this.controls = [];
    this.tmpCompany = -1;
    this.tmpSede = -1;
    this.changePassword = false;
    this.modalRef.hide();
  }

  /**
   * Validad que las contraseñas del formulario de creacion de login coincidan
   * para pasar con la confirmacion de creacion
   *
   * @memberof CreateUserLoginComponent
   */
  validPassword() {
    let valid = true;
    if (this.formLogin.valid) {
      if (this.formLogin.controls['txtPassword'].valid && this.formLogin.controls['txtRedPassword'].valid) {
        if (this.formLogin.controls['txtPassword'].value === this.formLogin.controls['txtRedPassword'].value) {
          this.confirm();
        } else {
          valid = false;
        }
      } else {
        valid = false;
      }
      if (!valid) {
        this.toastr.warning('Las contraseñas no coinciden, verifica e intentalo de nuevo');
      }
    } else {
      // tslint:disable-next-line:max-line-length
      this.toastr.warning('El formulario no es valido, verifiquelo y vuelva a intentarlo', 'Problemas en el formulario');
    }
  }

  /**
   * Setea la pregunta correspondiente a la accion y abre la modal de confirmaciones
   *
   * @param {*} [data]
   * @memberof CreateUserLoginComponent
   */
  confirm (data?: any) {
    if (this.update) {
      if (data) {
        this.dataFormUpdate = data;
      }
      if (this.changePassword) {
        this.question = '¿Realmente desea cambiar la contraseña?';
      } else {
        this.question = '¿Realmente desea actualizar el login de este usuario?';
      }
    } else {
      this.question = 'Desea registrar el login a este usuario usuario?';
    }
    this.confirmAction.open();
  }

  /**
   * Crea o edita el login ademas de realizar el cambio de contraseña del login
   *
   * @param {*} res
   * @memberof CreateUserLoginComponent
   */
  saved(res: any) {
    let user: LoginSaved;
    if (res && this.update) {
      if (!this.changePassword) {
        user = {
          username: this.dataFormUpdate.txtUserName,
          is_active: this.dataFormUpdate.chActive,
          user_groups: this.dataFormUpdate.cboGroups,
          sede: this.dataFormUpdate.cboSede,
          cargo: this.dataFormUpdate.cboCharge,
        };
      } else {
        user = {
          password: this.formChangePassword.controls['txtRedPassword'].value
        } as LoginSaved;
      }
      this.culds.updateUserLogin(this.userLogin.id, user).subscribe(resUpdate => {
        if (resUpdate) {
          if (!this.changePassword) {
            this.closeForm();
            this.sended.emit(true);
          } else {
            this.closeChangePassword();
          }
        }
      });
    } else if (res) {
      user = {
        username: this.formLogin.controls['txtNameUser'].value,
        password: this.formLogin.controls['txtRedPassword'].value,
        is_active: this.formLogin.controls['chActive'].value,
        user_groups: this.formLogin.controls['cboGroups'].value,
        sede: this.formLogin.controls['cboSede'].value,
        cargo: this.formLogin.controls['cboCharge'].value,
      };
      this.culds.addUserLogin(user).subscribe(data => {
        if (data) {
          const form = {
            userLogin: data.id
          };
          this.tds.updateInformationDynamicTableMaster(this.idRegistration, form, true).subscribe(resp => {
            if (resp) {
              this.closeForm();
              this.sended.emit(true);
            }
          });
        }
      });
    }
  }

  /**
   * Cierra el formulario de cambio de contraseña
   *
   * @memberof CreateUserLoginComponent
   */
  closeChangePassword() {
    this.changePassword = false;
    this.formChangePassword.reset();
  }


  /**
   * Valida las contraseñas del formulario de cambio de contraseña que coincidan
   * para abrir la modal de confirmaciones
   *
   * @memberof CreateUserLoginComponent
   */
  validChangePassword() {
    let valid = true;
    if (this.formChangePassword.valid) {
      if (
        this.formChangePassword.controls['txtPassword'].valid &&
        this.formChangePassword.controls['txtRedPassword'].valid
      ) {
        // tslint:disable-next-line:max-line-length
        if (this.formChangePassword.controls['txtPassword'].value === this.formChangePassword.controls['txtRedPassword'].value) {
          this.confirm();
        } else {
          valid = false;
        }
      } else {
        valid = false;
      }

      if (!valid) {
        this.toastr.warning('Las contraseñas no coinciden, verifica e intentalo de nuevo');
      }
    } else {
      // tslint:disable-next-line:max-line-length
      this.toastr.warning('El formulario no es valido, verifiquelo y vuelva a intentarlo', 'Problemas en el formulario');
    }
  }

  /**
   * Controla los cambios de el formulario de edicion de el login para cargar los selects con la informacion correcta
   *
   * @param {*} data
   * @memberof CreateUserLoginComponent
   */
  changeForm(data: any) {
    if (data.change) {
      if (!this.detectChangeForm) {
        this.detectChangeForm = true;
        const tmpLogin: Login = {
          is_active: data.change.chActive,
          username: data.change.txtUserName,
          groups: data.change.cboGroups,
          empresa: {
            id: data.form.controls['cboCompany'].value,
            nombre: '',
            descripcion: ''
          },
          sede: {
            id: data.change.cboSede,
            nombre: '',
            descripcion: '',
            empresa: data.form.controls['cboCompany'].value
          },
          cargo: {
            id: data.change.cboCharge,
            nombre: '',
          },
        };
        tmpLogin['groups_user'] = data.change.cboGroups;
        if (data.change.cboCompany && this.tmpCompany !== Number(data.change.cboCompany)) {
          this.tmpCompany = Number(data.change.cboCompany);
          delete tmpLogin.sede;
          if (!this.update) {
            this.formLogin.controls['cboSede'].reset();
          }
          this.culds.getSedes(Number(data.change.cboCompany)).subscribe(sedes => {
            this.optSedes = [];
            if (sedes && sedes.length) {
              sedes.forEach(sede => {
                this.optSedes.push({
                  key: sede.id,
                  value: sede.nombre
                });
              });
              this.options['optSedes'] = this.optSedes;
              this.controls = this.culfs.getFieldsCompensaciones(this.options, this.templates, tmpLogin);
            }
          });
        }
        this.detectChangeForm = false;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/teacher/create-user-login/create-user-login.component.ts